import { render, staticRenderFns } from "./transportDetails.vue?vue&type=template&id=688bf130&scoped=true"
import script from "./transportDetails.vue?vue&type=script&lang=js"
export * from "./transportDetails.vue?vue&type=script&lang=js"
import style0 from "./transportDetails.vue?vue&type=style&index=0&id=688bf130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688bf130",
  null
  
)

export default component.exports